import { t } from "../../../services/utils";
import React from "react";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
import { calculateTextHeight, htmlLines } from "../../../services/utils";
class TextView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        display: "flex",
        backgroundColor: "white",
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: this.props.paddingTop ? this.props.paddingTop : 16,
        paddingBottom: this.props.paddingBottom ? this.props.paddingBottom : 16,
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
      },
      text: {
        flex: "1 1 auto",
        fontSize: 16,
        wordBreak: "break-word",
      },
    };
    return (
      <div style={styles.container} data-testid="story-text">
        <div style={styles.text}>{htmlLines(this.props.text)}</div>
      </div>
    );
  };
  static getHeight(props) {
    let width = STORY_VIEW_WIDTH - 20;
    let textHeight = calculateTextHeight(props.text, width, {
      fontSize: 16,
    });
    let paddingTop = props.paddingTop ? props.paddingTop : 0;
    let paddingBottom = props.paddingBottom ? props.paddingBottom : 0;
    return paddingTop + paddingBottom + textHeight;
  }
}
export default TextView;
